import { Action } from "../../../types/state/action";
import { IMasterArtworkRequestHistory, MasterArtworkCollectionState } from "../collections/data.type";
import { MasterArtworkNumberState } from "../artwork-number/data.type";
import { IRequestStatusReason } from "../../../types/data.interface";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type MasterArtworkNameState = {
  id?: number | string;
  name: string;
  code: string;
  launch_date: string;
  collection: ValueOrNull<MasterArtworkCollectionState>;

  artwork_number_code: ValueOrNull<string>;
  artwork_number_file_url: ValueOrNull<string>;

  requestId: string;
  requestStatus: ValueOrNull<string>;
  requestDateFrom: string;
  requestDateTo: string;
  requestor: string;

  requestHistory: ValueOrNull<IMasterArtworkRequestHistory>;

  status?: string;
  comment?: string;

  submitComment: string;
  approveComment: string;
  rejectComment: string;
  rejectReason: IRequestStatusReason | null;

  hasUnsavedChanges: boolean;
  isValid: ValueOrNull<boolean>;
  isReadOnly:boolean;

};

export enum MasterArtworkNameActionTypes {
  SET_ARTWORK_NAME = "masterArtworkName/setArtworkName",
  RESET_STATE ="masterArtworkName/resetState",

  SET_NAME = "masterArtworkName/setName",
  SET_CODE = "masterArtworkName/setCode",
  SET_LAUNCH_DATE = "masterArtworkName/setLaunchDate",
  SET_ID = "masterArtworkName/setId",
  SET_COLLECTION = "masterArtworkName/setCollection",
  SET_ARTWORK_NUMBER_CODE = "masterArtworkName/setArtworkNumberCode",
  SET_SUBMIT_COMMENT = "masterArtworkName/setSubmitComment",

  SET_APPROVE_COMMENT = "masterArtworkName/setApproveComment",
  SET_REJECT_COMMENT = "masterArtworkName/setRejectComment",
  SET_REJECT_REASON = "masterArtworkName/setRejectReason",
  SET_ARTWORK_NUMBER_FILE_NAME = "masterArtworkName/setArtworkNumberFileName",
  SET_IS_VALID = "masterArtworkName/setIsValid",
  SET_REQUEST_STATUS = "masterArtworkName/setRequestStatus",
  SET_IS_READ_ONLY = "masterArtworkName/setIsReadOnly",
  SET_UNSAVED_CHANGES = "masterArtworkName/setUnsavedChanges",

  SET_FILTERS_FROM_STORAGE = "masterArtworkName/setFiltersFromStorage",
  RESET = "masterArtworkName/reset",
}

export type MasterArtworkNameActionType = Action<
  MasterArtworkNameActionTypes,
  Partial<MasterArtworkNameState>
>;
